/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';

import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, Resize, ForeignKey,
} from '@syncfusion/ej2-react-grids';
import { Query } from '@syncfusion/ej2-data';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

// import axios from 'axios';
import { Header } from '.';
// import { Methods } from '../pages/Methods';
import { langData } from '../data/dummy';

import '../pages/Zackat.css';

const SMS = ({ organization, orgs }) => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=organizations');
    return <p>Please login... </p>;
  }
  const { boss, zRenderMode, isMobile } = useStateContext();

  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const toolbarOptions = ['Search', 'Add', 'Edit', 'Delete'];
  const { REACT_APP_API_ENDPOINT } = process.env;
  const selectionSettings = { mode: 'Row', type: 'Single' };
  const valuerules = { required: true };
  const [orgData] = useState(orgs);
  const editing = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Dialog',
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    if (usr.organizationid === 'na') {
      usr.organizationid = organization._id;
    }
    // fetch data
    const smsFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/sms_config?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    smsFetch();
  }, [reload]);
  const [sysTypes, setSysTypes] = useState([
    { value: 'user', text: 'User' },
  ]);
  useEffect(() => {
    const myTypes = [
      { value: 'user', text: 'User' },
    ];
    if (boss) {
      myTypes.push({ value: 'system', text: 'System' });
    }
    setSysTypes(myTypes);
  }, [boss]);
  const grid = useRef(null);
  const actionComplete = (args) => {
    if (args.requestType === 'save' && args.action === 'add') {
      if (args.data && args.data.name) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        fetch(`${REACT_APP_API_ENDPOINT}/sms_config`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.id) {
              args.data.id = responseJson.id;
              const rowInfo = args.data;
              grid.current.setRowData(responseJson.id, rowInfo.rowData);
              DialogUtility.alert(`SMS has been added ${args.data.name}!`);
              setReload(!reload);
            } else {
              DialogUtility.alert(`response ${responseJson.response}`);
            }
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Insert!');
          });
      }
    } else if (args.requestType === 'save' && args.action === 'edit') {
      if (args.data && args.data.name) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        fetch(`${REACT_APP_API_ENDPOINT}/sms_config`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response === 'OK') {
              DialogUtility.alert(`SMS Update ${responseJson.response}`);
            } else {
              DialogUtility.alert(`SMS Update Failed ${responseJson.response}`);
            }
          })
          .catch((error) => {
            DialogUtility.alert(`SMS Update ${error.message}`);
          });
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/sms_config`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            DialogUtility.alert('SMS has been removed!');
            setReload(!reload);
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Delete!');
          });
      } else {
        args.cancel = false;
      }
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  /*
  if (data && data.organization) {
    data.organization.forEach((org) => {
      orgData.push({ id: org._id, value: org.title });
    });
  }
  */
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: orgData,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <Header category="" title={`${organization.title} Available SMS`} />
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data.sms}
              width="auto"
              allowPaging
              allowSorting
              editSettings={editing}
              toolbar={toolbarOptions}
              actionComplete={actionComplete}
              selectionSettings={selectionSettings}
              enableHover={false}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowResizing
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <ColumnDirective
                  field="id"
                  headerText="ID"
                  width="100"
                  isPrimaryKey
                  visible={false}
                />
                <ColumnDirective
                  field="name"
                  headerText="Name"
                  width="150"
                  validationRules={valuerules}
                  visible
                />
                <ColumnDirective
                  field="syntax"
                  headerText="Syntax"
                  width="150"
                  validationRules={valuerules}
                  visible
                />
                <ColumnDirective
                  field="sysType"
                  headerText="Type"
                  width="100"
                  editType="dropdownedit"
                  visible
                  foreignKeyField="value"
                  foreignKeyValue="text"
                  dataSource={sysTypes}
                />
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="150"
                  textAlign="Center"
                  editType="dropdownedit"
                  edit={organizations}
                  validationRules={valuerules}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, Resize, ForeignKey]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SMS;
